import React from "react";
import "./sobre-aluno-style.css";
import CardInfo from "../card";


function SobreAluno(props) {
    return (
        <>
        <div className="cards">

            <div className="primeira-col-2">
                <h2 className='titulo'>DADOS PESSOAIS</h2>
                <CardInfo data={props.data.diploma.diplomado}/>
            </div>

            <div className="primeira-col-2">
                <h2 className='titulo'>IES EMISSORA</h2>
                <CardInfo data={props.data.diploma.ies_emissora}/>
            </div>

            <div className="primeira-col-2">
                <h2 className='titulo'>IES REGISTRADORA</h2>
                <CardInfo data={props.data.diploma.ies_registradora}/>
            </div>

            <div className="primeira-col-2">
                <h2 className='titulo'>DADOS DO CERTIFICADO</h2>
                <CardInfo data={props.data.diploma.livro_registro}/>
            </div>

        </div>
            {props.data.diploma.livro_registro[3].value === null &&
                <h1 className='text-center font'>A data de emissão do seu diploma é anterior a 25 de abril de 2019 e não
                    possui data de publicação no Diário Oficial devido à não obrigatoriedade, conforme estabelecido no
                    Artigo 23 da Portaria Nº 1095/2018, de 25 de outubro de 2018. Se precisar de comprovação, você pode
                    abrir o protocolo ACADÊMICO | DECLARAÇÃO DE AUTENTICIDADE DE DIPLOMAS.</h1>
            }
        </>
    );
}

export default SobreAluno;

